import { useTranslation } from 'react-i18next'
import React from 'react'

import { placeTypesOptions } from '../../qrcodes/_constants/placeTypes'
import { useForm } from '../../../packages/kiti/components/form/form/FormHandler'
import { useSaveForms } from './_requests/saveForms'
import BulkForm from '../../../packages/kiti/components/form/form/BulkForm'
import ChecklistSelect from '../../../containers/checklists/select/ChecklistSelect'
import FieldSelect from '../../../containers/fields/FieldSelect'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Select from '../../../components/form/Select'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import Switch from '../../../components/form/Switch'
import TagPicker from '../../../components/form/TagPicker'
import TextArea from '../../../packages/kiti/components/form/Textarea'

const sharingOptions = t => [
  { label: t('private'), value: 'private' },
  { label: t('public'), value: 'public' }
]

const EditForms = () => {
  const { t } = useTranslation('editFormV2')
  const form = useForm()
  const [onSubmit, { loading, error }] = useSaveForms()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={[form, {}]}>
      <Scroll height="69vh" scroll scrollX direction="row">
        <Separator weight={8} flex={1}>
          <BulkForm
            fields={[
              { label: t('name'), name: 'name', width: 15 },
              { label: t('checklist'), name: 'checklist', Input: ChecklistSelect },
              { label: t('description'), name: 'description', Input: TextArea },
              { label: t('access'), name: 'access', Input: TagPicker, options: sharingOptions(t), width: 15 },
              {
                label: t('validationRequired'),
                name: 'validationRequired',
                Input: Switch,
                disabled: form => !(form.access === 'private')
              },
              {
                label: t('placeType'),
                name: 'placeType',
                Input: Select,
                options: placeTypesOptions
              },
              {
                label: t('validationField'),
                name: 'validationPlaceFieldId',
                Input: FieldSelect,
                filter: { origins: form.placeType },
                disabled: form => !form.validationRequired || !(form.access === 'private')
              }
            ]}
          />
        </Separator>
      </Scroll>
      <Line />
      <Separator paddingH={2}>
        <SubmitBar loading={loading} error={error} />
      </Separator>
    </Form>
  )
}

export default EditForms
